import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Tab,
  Tabs,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import CustomTabPanel from "../../APS/Operation/CustomTabPanel";
import styled from "styled-components";
import { GanttIFframe } from "../../APS/AiGantt/styles";
import APS_URL from "../../../utils/APS_URL";
import { useParams } from "react-router-dom";
import myTheme from "../../common/DataGrid/ag-grid-theme-builder";

const StyledTabsIndex = styled(Tabs)`
  font-size: 16px;
  margin: 0 1rem;
  & div:nth-of-type(2) div {
    justify-content: flex-start !important;
  }
  
  /* 선택되지 않은 탭 텍스트 색상 */
  & .MuiTab-root {
    color: #ced4da !important;
  }
`;

const columnDefs = [
  {
    field: "item_name",
    headerName: "제품명",
    flex: 1,
    minWidth: 140,
    headerClass: "ag-header-center",
    cellStyle: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  {
    field: "proc_name",
    headerName: "공정명",
    flex: 1,
    minWidth: 140,
    headerClass: "ag-header-center",
    cellStyle: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  {
    field: "order_name",
    headerName: "주문명",
    flex: 1,
    minWidth: 140,
    headerClass: "ag-header-center",
    cellStyle: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  {
    field: "product_qty",
    headerName: "생산 수량",
    flex: 1,
    minWidth: 140,
    headerClass: "ag-header-center",
    cellStyle: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  {
    field: "start_date",
    headerName: "시작시간",
    flex: 1,
    minWidth: 140,
    headerClass: "ag-header-center",
    cellStyle: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    sort: "asc",
  },
  {
    field: "end_date",
    headerName: "종료시간",
    flex: 1,
    minWidth: 140,
    headerClass: "ag-header-center",
    cellStyle: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
];

function WorkOrderModal({ open, onClose, data, assetInfo }) {
  const { group_code, project_code } = useParams();
  const gridOptions = {
    pagination: true,
    paginationPageSize: 20,
    rowHeight: 52,
    headerHeight: 52,
    suppressCellFocus: true,
    defaultColDef: {
      sortable: true,
      filter: false,
      resizable: true,
    },
    suppressMenuHide: true,
    suppressContextMenu: true,
    enableCellTextSelection: false,
  };
  const [currentTab, setCurrentTab] = useState(0);
  const handleDialogClose = (event) => {
    event.stopPropagation();
    onClose();
    setCurrentTab(0);
  };
  const mchName = !data.length ? "장비 미연동" : data[0].mch_name;
  const handleTabChange = (_, newValue) => {
    setCurrentTab(newValue);
  };
  return (
    <>
      <Dialog
        fullWidth
        open={open}
        maxWidth="lg"
        scroll="body"
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            onClose();
          }
        }}
        sx={{
          "& .MuiDialog-paper": {
            overflow: "visible",
            backgroundColor: "rgba(47, 51, 73, 0.8);",
            border: "solid 2px rgb(63 68 99)",
          },
        }}
      >
        <Box
          sx={{
            borderBottom: "solid 1px #464646;",
            padding: "16px 24px",
          }}
        >
          <Typography variant="h3" sx={{ color: "#ced4da" }}>
            작업 지시서 - {mchName}
          </Typography>
        </Box>
        <StyledTabsIndex
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="작업지시서" />
          <Tab label="Gantt차트" />
        </StyledTabsIndex>
        <CustomTabPanel value={currentTab} index={0}>
          <DialogContent
            sx={{
              px: (theme) => [
                `${theme.spacing(5)} !important`,
                `${theme.spacing(10)} !important`,
              ],
              py: (theme) => [
                `${theme.spacing(8)} !important`,
                `${theme.spacing(10)} !important`,
              ],
            }}
          >
            <div style={{ height: "500px", width: "100%" }}>
              <AgGridReact
                rowData={data}
                columnDefs={columnDefs}
                gridOptions={gridOptions}
                theme={myTheme}
                suppressFiltersToolPanel={true}
                suppressColumnFilter={true}
                suppressRowClickSelection={true}
              />
            </div>
          </DialogContent>
        </CustomTabPanel>
        <CustomTabPanel value={currentTab} index={1}>
          <DialogContent
            sx={{
              px: (theme) => [
                `${theme.spacing(5)} !important`,
                `${theme.spacing(10)} !important`,
              ],
              py: (theme) => [  
                `0 !important`
              ],
            }}
          >
            <GanttIFframe
              title="gantt"
              style={{ width: "100%", height: "590px", overflow: "hidden" }}
              src={`${APS_URL}/dt_gantt_mch?group_code=${group_code}&project_code=${project_code}&mch_id=${data[0]?.mch_id}`}
            />
          </DialogContent>
        </CustomTabPanel>
        <DialogActions sx={{ padding: "0 1rem 1rem 1rem" }}>
          <Button onClick={handleDialogClose} color="primary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default WorkOrderModal;
